import * as PIXI from 'pixi.js'

type BitmapTextStyle = Partial<PIXI.IBitmapTextStyle>
type TextStyle = Partial<PIXI.ITextStyle>

export const MULTIPLIER_VALUE_STYLE: BitmapTextStyle = {
    fontName: 'bitmapFont_1',
    letterSpacing: -10
}

export const TOP_PANEL_VALUE_STYLE: TextStyle = {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 3,
    dropShadowColor: "#0f0000",
    dropShadowDistance: 5,
    fill: "#ffffff",
    fontFamily: "Roboto-Black",
    fontSize: 38,
}

export const TOP_PANEL_TITLE_STYLE: TextStyle = {
    fontFamily: 'Agbalumo',
    align: 'center',
    fill: "#ce0285",
    fontSize: 28,
    lineJoin: "round",
    stroke: "#fff5ab",
    strokeThickness: 10,
    fontWeight: 'bold'
}

export const WIN_LABEL_STYLE: TextStyle = {
    dropShadow: true,
    dropShadowAngle: 1.4,
    dropShadowBlur: 2,
    dropShadowColor: "#130000",
    dropShadowDistance: 7,
    fill: "#ffffff",
    fontFamily: "Roboto-Black",
    fontSize: 68,
}

export const POPUP_TITLE_STYLE: TextStyle = {
    fontFamily: 'Agbalumo',
    align: 'center',
    fill: "#fbc848",
    fontSize: 100,
    lineJoin: "round",
    stroke: "#a52325",
    strokeThickness: 10,
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 14,
    dropShadowColor: "#a52325",
    dropShadowDistance: 1
}

export const POPUP_STYLE: TextStyle = {
    fontFamily: 'Agbalumo',
    align: 'center',
    fill: "#fbc848",
    fontSize: 60,
    lineJoin: "round",
    stroke: "#a52325",
    strokeThickness: 10,
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 8,
    dropShadowColor: "#a52325",
    dropShadowDistance: 1
}

export const POPUP_SMALL_STYLE: TextStyle = {
    fontFamily: 'Roboto-Black',
    align: 'center',
    fontSize: 34,
    fill: "#b7185e",
    fontWeight: 'bold'
}
